import { basePermissionManagerApi as api } from '../basePermissionManagerApi';
export const addTagTypes = ['Namespace'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getNamespaces: build.query<GetNamespacesApiResponse, GetNamespacesApiArg>(
        {
          query: () => ({ url: `/namespaces` }),
          providesTags: ['Namespace'],
        },
      ),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as baseGeneratedApi };
export type GetNamespacesApiResponse = unknown;
export type GetNamespacesApiArg = void;
export const { useGetNamespacesQuery } = injectedRtkApi;
